<div class="zint-base-card d-flex justify-content-between w-100">
  <span class="text-grey-600">Enable this option to automatically enrich your {{crmType}} data with Zint insights on a regular schedule.</span>
  @if (crmService.wizardLoading().isLoadingWizardStep) {
    <zint-loader size="xSmall"></zint-loader>
  }
  <mat-slide-toggle [color]="'primary'" [(ngModel)]="enableEnrichment"
    (change)="updateChoiceAndGetStatus()">
  </mat-slide-toggle>
</div>

  <div class="zint-base-card zint-card-light mt-3 d-flex flex-gap-05 align-items-baseline">
    <i class="fas fa-circle-info"></i>
    <div>
      <span>If enabled, Zint will attempt to match and update your {{crmType | titlecase}} records based on the configured lookup fields and
      mappings. This process runs weekly.</span>      
    </div>
  </div>